import { useEffect } from 'react';
import { siteConfig } from '../config/site';

interface SeoProps {
  title: string;
  description: string;
}

export function Seo({ title, description }: SeoProps) {
  useEffect(() => {
    document.title = `${title} | ${siteConfig.organizationName}`;

    const descriptionElement = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );

    if (descriptionElement) {
      descriptionElement.content = description;
    }
  }, [description, title]);

  return null;
}
